export default __webpack_public_path__ + "static/media/team_dancing_top.66c7487c.png";